import { useMemo } from 'react';

/**
 * props:
 * - type
 * - isFuture
 * - onChange
 */
function OrderType(props) {

    const orderType = useMemo(() => {
        return (
            <div className="form-group">
                <label htmlFor="type">Tipo:</label>
                <select id="type" className="form-select" value={props.type} onChange={props.onChange}>
                    <option value="LIMIT">Limite</option>
                    <option value="MARKET">Mercado</option>
                    {
                        props.isFuture
                            ? (
                                <>
                                    <option value="STOP">Stop Loss Limite</option>
                                    <option value="STOP_MARKET">Stop Loss Mercado</option>
                                    <option value="TAKE_PROFIT">Take Profit Limite</option>
                                    <option value="TAKE_PROFIT_MARKET">Take Profit Mercado</option>
                                    <option value="TRAILING_STOP_MARKET">Trailing Stop</option>
                                </>
                            )
                            : (
                                <>
                                    <option value="STOP_LOSS_LIMIT">Stop Loss Limite</option>
                                    <option value="TAKE_PROFIT_LIMIT">Take Profit Limite</option>
                                    <option value="TRAILING_STOP">Trailing Stop</option>
                                </>
                            )
                    }
                </select>
            </div>
        )
    }, [props.type, props.isFuture])

    return orderType;
}

export default OrderType;